<template>
  <a class="editor-link">
    <slot/>
  </a>
</template>

<script>
  export default {
    name: 'EditorLink'
  }
</script>

<style lang="sass" scoped>
  @use '../../styles/variables' as v

  .editor-link
    background: none
    border: none
    //padding: 12px 9px 8px
    padding: 8px 9px 8px
    font-family: v.$font-family
    font-size: v.$font-size-small
    border-bottom: 1px solid v.$gray2
    color: v.$light-gray3
    height: 100%
    transition: color 0.15s ease-in-out
    outline: none
    display: block
    position: relative

    &:hover
      color: v.$white

    .svg-icon
      position: absolute
      top: 0
</style>
